(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["info-cards-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof Swiper !== 'undefined') {
      new Swiper('.swiper', {
        slidesPerView: 1.2,
        spaceBetween: 16,
        loop: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
